import { NextPageContext } from 'next';
import { apiCall } from '@/utils/api';

export const getCollections = async (
  lookup: string,
  selectedCollectionId: string | null,
  params: string,
  req?: NextPageContext['req'],
) => {
  const COLLECTIONS_ROUTE = '/collections';
  // validate that request is not made for "all" lookup & unique collection simultaneously
  const isValidUniqueUrlPattern = selectedCollectionId && lookup !== '';

  try {
    const collections = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${COLLECTIONS_ROUTE}/${lookup}${
        isValidUniqueUrlPattern ? `/${selectedCollectionId}` : ''
      }${params}`,
      {
        method: 'GET',
        headers: {
          cookie: req?.headers.cookie,
        },
      },
    );
    return collections;
  } catch (error: any) {
    return null;
  }
};

export const getSingleCollection = async (collectionId: string) => {
  const COLLECTION_ROUTE = '/collections/collection/';

  try {
    const collection = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${COLLECTION_ROUTE}${collectionId}`,
      {
        method: 'GET',
      },
    );
    return collection;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getCollectionFrames = async (
  collectionId: string | string[] | null,
  req?: NextPageContext['req'],
) => {
  const COLLECTION_ROUTE = '/collections/frames/';

  try {
    const collection = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${COLLECTION_ROUTE}${collectionId}`,
      {
        method: 'GET',
        headers: {
          cookie: req?.headers.cookie,
        },
      },
    );
    return collection;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getCollectionCoverage = async (
  collectionId: string | string[] | null,
  req?: NextPageContext['req'],
) => {
  const COLLECTION_ROUTE = '/collections/coverage/';

  try {
    const collection = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${COLLECTION_ROUTE}${collectionId}`,
      {
        method: 'GET',
        headers: {
          cookie: req?.headers.cookie,
        },
      },
    );
    return collection;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getCollectionReviews = async (collectionId: string) => {
  const COLLECTION_REVIEWS_ROUTE = '/collections/reviews/';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${COLLECTION_REVIEWS_ROUTE}${collectionId}`,
      {
        method: 'GET',
      },
    );
    return response;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getDashcamStats = async (collectionId: string) => {
  const DASHCAM_STATS_ROUTE = '/collections/collection/dashcam/stats/';

  try {
    const speeds = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${DASHCAM_STATS_ROUTE}${collectionId}`,
      {
        method: 'GET',
      },
    );
    return speeds;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const reprocessCollection = async (collectionId: string) => {
  try {
    const { success } = await apiCall(
      `${process.env.NEXT_PUBLIC_API}/collections/reprocess/${collectionId}`,
      {
        method: 'POST',
      },
    );
    return success;
  } catch (error: any) {
    throw new Error(error);
  }
};
